import { Common, Messages } from '@/config/NextImport'
import { createSlice } from '@reduxjs/toolkit'
import Cookies from 'js-cookie'

const initialState: any = {
  userData: {
    isLoggedIn: false,
    user: null,
    session_token: ''
  }
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    LoggedInUser: (state) => {
      const encryptedData = Cookies.get(Messages.WebsiteAppState) || undefined
      if (encryptedData) {
        const decryptedData = Common.decryptData(encryptedData) || ''
        state.userData = JSON.parse(decryptedData)
      } else {
        state.userData = {
          isLoggedIn: false,
          user: null,
          session_token: ''
        }
      }
    }
  }
})

export const { LoggedInUser } = userSlice.actions

export default userSlice.reducer
